/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AppEnvironmentStrictHttpResponse } from '../../app-environment-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceIdentifierModel } from '../../models/device-identifier-model';
import { IAppEnvironment } from '../../models/i-app-environment';

export interface AppEnvironmentSettingsPost$Params {
      body?: DeviceIdentifierModel
}

export function appEnvironmentSettingsPost(http: HttpClient, rootUrl: string, params?: AppEnvironmentSettingsPost$Params, context?: HttpContext): Observable<AppEnvironmentStrictHttpResponse<IAppEnvironment>> {
  const rb = new RequestBuilder(rootUrl, appEnvironmentSettingsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AppEnvironmentStrictHttpResponse<IAppEnvironment>;
    })
  );
}

appEnvironmentSettingsPost.PATH = '/AppEnvironment/Settings';
